/**
 * A que radiologos atiende un transcriptor.
 *
 * De esta asignacion sale su cola de trabajo: sin radiologos asignados, su
 * pantalla esta vacia. Lo administra el ADMIN desde Usuarios.
 */

import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { get, post } from '@/lib/api'
import { API_ROUTES } from '@/config/constants'

const clave = (userId: string) => ['transcriptor-radiologos', userId] as const

export function useRadiologosDelTranscriptor(userId: string | undefined) {
  return useQuery({
    queryKey: clave(userId ?? ''),
    enabled: !!userId,
    queryFn: async () => {
      const r = await get<{ radiologistIds: string[] }>(
        API_ROUTES.TRANSCRIPTOR_RADIOLOGOS.BY_USER(userId as string)
      )
      return r.radiologistIds
    },
  })
}

export function useAsignarRadiologos(userId: string) {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (radiologistIds: string[]) => {
      const r = await post<{ radiologistIds: string[] }>(
        API_ROUTES.TRANSCRIPTOR_RADIOLOGOS.UPDATE(userId),
        { radiologistIds }
      )
      return r.radiologistIds
    },
    onSuccess: (ids) => {
      queryClient.setQueryData(clave(userId), ids)
      // La cola del transcriptor cambia con esto.
      queryClient.invalidateQueries({ queryKey: ['reports'] })
    },
  })
}
